module.exports = __webpack_public_path__ + "img/productHome8.4c37bee2.png";